<template>
  <div>
    <label
      :class="negrita == 'true' ? 'mb-1 w-100 font-weight-bold' : 'mb-1 w-100'"
      for="numserie"
      >N&uacute;mero de serie/documento</label
    >
    <b-input-group class="borde-amarillo">
      <b-col class="p-0">
        <b-form-input
          :class="grande == 'true' ? 'form-control-lg' : ''"
          data-testid="form-cow"
          type="text"
          class="placeholder boton-prepend"
          placeholder="A012345678/123.456.789"
          :state="state"
          maxlength="11"
          @change.native="change"
          @input.native="handler"
          @blur="blur"
          @keyup="keyup"
          :value="value"
          autocomplete="off"
        />
      </b-col>

      <b-col cols="auto" class="p-0">
        <b-input-group-text
          slot="append"
          class="bg-white boton-append h-100 d-flex"
          id="popovercarnet1"
        >
          <a class="text-secondary">
            <font-awesome-icon icon="info" class="m-0" />
          </a>
          <b-popover
            target="popovercarnet1"
            placement="left"
            triggers="hover focus"
            data-testid="form-popover"
          >
            <h6 class="text-center">
              ¿Dónde consigo el número de serie/documento?
            </h6>
            <img
              src="https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/numero-documento.png"
              class="img-fluid"
            />
            <br />
            <br />
            <img
              src="https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/serie.png"
              class="img-fluid"
            />
             <p class="text-secondary">
              Si tienes RUN de enrolamiento (Artículo 44), en el número de
              serie/documento debes ingresar el mismo RUN, incluyendo el dígito
              verificador, pero sin puntos ni guion. Si el dígito verificador es
              K, debes reemplazarlo por un 1. Por ejemplo, si tu RUN es
              24.123.456-K, debes ingresar 241234561
            </p>
          </b-popover>
        </b-input-group-text>
      </b-col>
    </b-input-group>
    <div class="mensaje-error">{{ mensajeError }}</div>
  </div>
</template>
<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faInfo);
export default {
  props: ["negrita", "state", "mensajeError", "grande", "value"],
  components: {
    FontAwesomeIcon
  },
  methods: {
    handler(evento) {
      this.$emit("input", evento.target.value);
    },
    change(evento) {
      this.$emit("change", evento);
    },
    blur(evento) {
      this.$emit("blur", evento);
    },
    keyup(evento) {
      this.$emit("keyup", evento);
    }
  }
};
</script>
<style scoped>
.boton-append {
  border-radius: 0 0.25rem 0.25rem 0;
  border-left: 0ch;
}
.boton-prepend {
  border-radius: 0.25rem 0 0 0.25rem;
}
.mensaje-error {
  font-size: 80%;
  color: #dc3545;
}
</style>



// WEBPACK FOOTER //
// src/components/generales/inputs/InputWrapperSerie.vue